import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LegalFooterComponent } from '../shared/legal-footer/legal-footer.component';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [CommonModule, RouterModule, LegalFooterComponent],
  templateUrl: './terms.component.html',
  styleUrls: ['../shared/legal-pages.styles.scss']
})
export class TermsComponent {
  currentDate = new Date();

  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['/']);
  }
}